export default "__VITE_ASSET__CKHI2TkB__"